import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBorderInput, space1, space2, space4, space6, space8, colorTextMedium } = theme();

  return StyleSheet.create({
    backButton: {
      marginBottom: space4,
    },
    image: {
      borderColor: colorBorderInput,
      borderWidth: 1,
      height: 70,
      marginRight: space2,
      width: 56,
    },
    imagesContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      height: 70,
      justifyContent: "center",
      marginBottom: space6,
    },
    modalContent: {
      paddingHorizontal: space6,
    },
    moreProductsContainer: {
      borderColor: colorBorderInput,
      borderWidth: 1,
      display: "flex",
      height: 70,
      justifyContent: "center",
      width: 56,
    },
    moreProductsText: {
      color: colorTextMedium,
      marginBottom: space8,
      textAlign: "center",
    },
    title: {
      marginBottom: space1,
      width: "100%",
    },
  });
};

export { style };
